import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "11",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#D3EFEC",
      "fill-rule": "evenodd",
      d: "M.787 2.2a1.6 1.6 0 0 1 1.6-1.6h3.669a1.6 1.6 0 0 1 1.131.469L9.918 3.8c.3.3.47.707.47 1.131v6.87a1.6 1.6 0 0 1-1.6 1.6h-6.4a1.6 1.6 0 0 1-1.6-1.6zm1.6 4.8a.8.8 0 0 1 .8-.8h4.8a.8.8 0 1 1 0 1.6h-4.8a.8.8 0 0 1-.8-.8m.8 2.4a.8.8 0 1 0 0 1.6h4.8a.8.8 0 0 0 0-1.6z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }